const REDIRECT_PATH_BASE = 'https://placeholder.invalid';

export const getSafeCurrentPath = (location = window.location): string => {
  const { pathname, search } = location;
  const redirectPath = `${pathname}${search}`;
  const url = new URL(redirectPath, REDIRECT_PATH_BASE);
  if (!redirectPath.startsWith('/') || url.origin !== REDIRECT_PATH_BASE || url.pathname.startsWith('//')) {
    throw new Error('Invalid authentication return path');
  }
  return `${url.pathname}${url.search}`;
};
